import React from "react";
import { Card, Progress, Image } from "antd";
import placeholderImg from "../../../assets/img/placeholder-image.webp";
import "./style.css"; // Make sure the path to the CSS file is correct

const { Meta } = Card;

function CustomCard({
  imageUrl,
  title,
  distance,
  unit,
  progress,
  remark,
  onClick,
}) {
  // Placeholder image if imageUrl is empty or null
  // const placeholderImage =
  //   "https://via.placeholder.com/300x200?text=No+Image+Available";

  return (
    <Card
      hoverable
      className="custom-card"
      cover={
        <div className="custom-card-cover">
          <img
            alt={title}
            src={imageUrl || placeholderImg} // Use placeholder if imageUrl is empty
            className="custom-card-image"
          />
          {/* <Image
            src={imageUrl || placeholderImg} // Use placeholder if imageUrl is empty
            alt={title}
            className="custom-card-image"
            fallback="https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.bishoprook.com%2Ftrail_ahead%2Fplaceholder-image-gray-16x9%2F&psig=AOvVaw3nIeHzMdxjr85mNDP9fH6N&ust=1758278302012000&source=images&cd=vfe&opi=89978449&ved=0CBUQjRxqFwoTCIj7oJ6P4o8DFQAAAAAdAAAAABAE"
          /> */}
          <div className="custom-card-overlay">
            <div className="custom-card-remark">
              <span>Remarks:</span>
              {remark}
            </div>
            <Progress
              percent={progress}
              showInfo={true}
              format={(percent) => `${percent}%`}
              className="custom-card-progress"
            />
          </div>
        </div>
      }
      onClick={onClick}
    >
      <Meta className="custom-card-meta" title={title} />
      <div className="custom-card-details">
        <span className="custom-card-label">
          {distance} {unit}
        </span>
      </div>
    </Card>
  );
}

export default CustomCard;
